module.exports = __webpack_public_path__ + "img/bco.8d692a33.svg";